//Participant/Update/{AuthToken}/{ParticipantGuid}/{GroupGuid}/{ParticipantGroupGuid}/{LanguageID}/{LastName}/{FirstName}/{MiddleName}/{BioDOB}/{BioGender}/{BioRace}/{BioRace2}/{BioRace3}/{SpokenLanguageID}/{Email}/{StatusID}/{EducationLevelGuid}/{Medicaid}/	

import React, { useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash"
import { Button, Grid, Typography, Box, Collapse, TextField, MenuItem } from '@mui/material'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { selectCountrys } from '../../../reducers/reference_country';
import { selectEducations } from '../../../reducers/reference_education';
import { selectSpokenLanguages } from '../../../reducers/reference_spokenlanguage';
import { selectParticipantDemographicsById, updateParticipantDemographics } from '../../../reducers/admincenter_participantdemographics';
import { selectMiscTypes } from '../../../reducers/reference_misctypes';
import { selectRaceEntities } from '../../../reducers/reference_race';
import { selectBirthSexs } from '../../../reducers/reference_birthsex';
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { adminparticipantModify, selectAdminParticipantById } from '../../../reducers/admincenter_participants';
import { createParticipantAddresss, selectParticipantAddresssByTypeGuid, updateParticipantAddresss } from '../../../reducers/admincenter_participantaddress';
import { createParticipantPhones, selectParticipantPhonesByTypeGuid, updateParticipantPhones } from '../../../reducers/admincenter_participantphone';
import { createParticipantMiscs, deleteParticipantMiscs, selectParticipantMiscs, updateParticipantMiscs } from '../../../reducers/admincenter_participantmisc';
import { AddCircleOutline, Delete } from '@mui/icons-material';


// WsWebServicePlatform/help

// Group/Participant/Create     POST BODY: has userName	

// Participant/Merge/{AuthToken}/{SourceParticipantGuid}/{TargetParticipantGuid}/	
// Group/Participant/Move/{AuthToken}/{ParticipantGuid}/{ToGroupGuid}/	

const ParticipantEdit = (props) => {
    const dispatch = useDispatch()

    const ParticipantGuid = props.Participant.ParticipantGuid
    const Participant = useSelector(state => selectAdminParticipantById(state, ParticipantGuid))
    const { user: currentUser } = useSelector((state) => state.auth);

    const ParticipantAdditionalInfo = useSelector(state => selectParticipantDemographicsById(state, Participant.ParticipantGuid))

    const countryData = useSelector(state => selectCountrys(state))
    const educationData = useSelector(state => selectEducations(state))
    const languageData = useSelector(state => selectSpokenLanguages(state))


    const raceData = useSelector(state => selectRaceEntities(state))
    const birthSexData = useSelector(state => selectBirthSexs(state))

    const langOptions = languageData.map((x) => {
        return (<MenuItem value={x.LanguageTypeId}>{x.StandardContent}</MenuItem>)
    })

    const eduOptions = educationData.map((x) => {
        return (<MenuItem value={x.EducationTypeGuid}>{x.EducationTypeName}</MenuItem>)
    })

    const countryOptions = countryData.map((x) => {
        return (<MenuItem value={x.CountryId}>{x.StandardContent}</MenuItem>)
    })

    const birthSexOptions = birthSexData.map((x) => {
        return (<MenuItem value={x.GenderTypeId}>{x.GenderTypeName}</MenuItem>)
    })

    const raceOptions = raceData.map((x) => {
        return (<MenuItem value={x.RaceTypeId}>{x.RaceTypeName}</MenuItem>)
    })

    const [localDemographicState, setLocalDemographicState] = useState({ ...Participant, ...ParticipantAdditionalInfo })

    const participantdemographicStatus = useSelector(state => state.participantdemographics.status)
    const participantaddressStatus = useSelector(state => state.participantaddresss.status)
    const participantphoneStatus = useSelector(state => state.participantphones.status)
    const participantmiscStatus = useSelector(state => state.participantmiscs.status)

    const participantdemographicError = useSelector(state => state.participantdemographics.error)
    const participantaddressError = useSelector(state => state.participantaddresss.error)
    const participantphoneError = useSelector(state => state.participantphones.error)
    const participantmiscError = useSelector(state => state.participantmiscs.error)

    const [isError, setIsError] = useState(false)
    const [isSaving, setIsSaving] = useState(false)

    const datToday = new Date(new Date().setDate(new Date().getDate() - 1));
    const dat120 = new Date()
    dat120.setFullYear(dat120.getFullYear() - 120)

    const validDob = !localDemographicState.BioDOB || (new Date(localDemographicState.BioDOB) >= dat120 && new Date(localDemographicState.BioDOB) < datToday)
    // useEffect(() => {
    //     if (
    //         participantdemographicStatus === 'success'
    //         && participantaddressStatus === 'success'
    //         && participantphoneStatus === 'success'
    //         && participantmiscStatus === 'success'
    //         && isSaving === true
    //     ) {
    //         setIsSaving(false)
    //         props.cancelButton()
    //     } else if (
    //         participantdemographicStatus === 'failed'
    //         || participantaddressStatus === 'failed'
    //         || participantphoneStatus === 'failed'
    //         || participantmiscStatus === 'failed'
    //     ) {
    //         setIsError(true)
    //         setIsSaving(false)
    //     }
    // }, [participantdemographicStatus, participantaddressStatus, participantphoneStatus, participantmiscStatus, isSaving])

    //phone
    const ParticipantPhone_Home = useSelector(state => selectParticipantPhonesByTypeGuid(state, "C05F6C51-5992-477C-BD94-7EE28E7CD4BD"))
    const ParticipantPhone_Mobile = useSelector(state => selectParticipantPhonesByTypeGuid(state, "9232B9CA-5C20-40C2-9190-25E302FDC0BE"))

    const basePhoneObject = {
        //  commenting out, a new object wont have this field  ParticipantPhoneGuid:"INPUT PhoneGUID",
        // will add this base on state ParticipantPhoneTypeGuid:"PhoneTypeGUID",
        ParticipantGuid: Participant.ParticipantGuid,
        Priority: 1,
        PhoneNumber: "",
    }
    const [localPhoneStateHome, setLocalPhoneStateHome] = useState(
        ParticipantPhone_Home[0]
        || { ...basePhoneObject, ParticipantPhoneTypeGuid: "C05F6C51-5992-477C-BD94-7EE28E7CD4BD" })
    const [localPhoneStateMobile, setLocalPhoneStateMobile] = useState(
        ParticipantPhone_Mobile[0]
        || { ...basePhoneObject, ParticipantPhoneTypeGuid: "9232B9CA-5C20-40C2-9190-25E302FDC0BE", Priority: 2 })
    // Cell	9232B9CA-5C20-40C2-9190-25E302FDC0BE
    // Home	C05F6C51-5992-477C-BD94-7EE28E7CD4BD
    // Work	7589F933-3B55-4974-B50E-2A6000C29456
    // address
    const ParticipantAddress = useSelector(state => selectParticipantAddresssByTypeGuid(state, "90899741-5728-4F9C-A489-691131304962"))
    const baseAddress = {
        //  commenting out, a new object wont have this field ParticipantAddressGuid:,
        ParticipantAddressTypeGuid: "90899741-5728-4F9C-A489-691131304962",
        ParticipantGuid: Participant.ParticipantGuid,
        Priority: 1,
        Address1: "",
        Address2: "",
        Address3: "",
        City: "",
        PostalCode: "",
        StateProvinceCounty: "",
        CountryCode: "",
        ParticipantAddressTypeName: "",
    }

    const [localAddressState, setLocalAddressState] = useState(ParticipantAddress[0] || baseAddress)

    // misc type
    const participantMiscTypes = useSelector(state => selectParticipantMiscs(state))
    const misctypeData = useSelector(state => selectMiscTypes(state))

    const [miscTypeState, setMiscTypeState] = useState(participantMiscTypes)
    const [miscTypeStateActualDelete, setMiscTypeStateActualDelete] = useState([])

    const miscTypeOptions = misctypeData.map((x) => {
        return (<MenuItem value={x.ParticipantMiscTypeGuid}>{x.MiscTypeName}</MenuItem>)
    })

    const AddMiscType = () => {
        let currentMisc = [...miscTypeState]
        currentMisc.push({ ParticipantGuid: Participant.ParticipantGuid, MiscData: "", ParticipantMiscTypeGuid: misctypeData[0] })
        setMiscTypeState(currentMisc)
    }
    const handleMiscTypeEdit = (index, key, value) => {

        let currentMisc = [...miscTypeState]
        currentMisc[index] = { ...currentMisc[index], [key]: value }
        setMiscTypeState(currentMisc)
    }
    const handleMiscTypeDelete = (index) => {
        let currentMisc = [...miscTypeState]
        let recordremoved = currentMisc.splice(index, 1); // 2nd parameter means remove one item only
        let oneRecord = recordremoved[0]
        //console.log('handle delete misc', { r: recordremoved, o: oneRecord })
        if (oneRecord.ParticipantMiscGuid) {
            let currentDelete = [...miscTypeStateActualDelete]
            currentDelete.push(oneRecord)
            setMiscTypeStateActualDelete(currentDelete)
        }
        setMiscTypeState(currentMisc)
    }

    // component stuff    
    const [isGroupExpanded, setIsGroupExpanded] = useState(true)
    const [isDemoExpanded, setIsDemoExpanded] = useState(false)
    const [isContactExpanded, setisContactExpanded] = useState(false)
    const [isOtherExpanded, setIsOtherExpanded] = useState(false)


    const handleAllChanges = (what) => {
        var currentTF
        switch (what) {
            case "DEMO":
                currentTF = isDemoExpanded
                break;
            case "CONTACT":
                currentTF = isContactExpanded
                break;
            case "OTHER":
                currentTF = isOtherExpanded
                break;
            case "GROUP":
                currentTF = isGroupExpanded
                break;
            default:
                break;
        }
        // default state is t / f / f / f
        // since only one can be true, the above code will tell us
        // what and the current incoming request.
        // if im false, and i come in, i should be true and the rest should be false
        // if im true, then i should just be false
        // therefore we only care if the current state is false

        // if my current state is false, then true.. else i should be false
        setIsGroupExpanded(!currentTF && what === "GROUP" ? true : false)
        setIsDemoExpanded(!currentTF && what === "DEMO" ? true : false)
        setisContactExpanded(!currentTF && what === "CONTACT" ? true : false)
        setIsOtherExpanded(!currentTF && what === "OTHER" ? true : false)

    }


    const sanitizeNull = (val) => {
        if (!val || val == -1) {
            return "~_~"
        } return val
    }

    const SaveToDatabase = () => {
        setIsError(false)
        setIsSaving(true)
        // save demographics
        let DemoToSave = {
            ...localDemographicState
            , authToken: currentUser.AuthToken
            , ParticipantGroupGuid: sanitizeNull(localDemographicState.ParticipantGroupGuid)
            , LanguageID: sanitizeNull(localDemographicState.LanguageID)
            , Lastname: sanitizeNull(localDemographicState.Lastname)
            , Firstname: sanitizeNull(localDemographicState.Firstname)
            , Middlename: sanitizeNull(localDemographicState.Middlename)
            , BioDOB: sanitizeNull(localDemographicState.BioDOB)
            , BioGender: sanitizeNull(localDemographicState.BioGender)
            , BioRace: sanitizeNull(localDemographicState.BioRace)
            , BioRace2: sanitizeNull(localDemographicState.BioRace2)
            , BioRace3: sanitizeNull(localDemographicState.BioRace3)
            , SpokenLanguageID: sanitizeNull(localDemographicState.SpokenLanguageID)
            , Email: sanitizeNull(localDemographicState.Email)
            , Status: sanitizeNull(localDemographicState.Status)
            , EducationLevelGuid: sanitizeNull(localDemographicState.EducationLevelGuid)
            , Medicaid: sanitizeNull(localDemographicState.Medicaid)
        }

        dispatch(updateParticipantDemographics(DemoToSave))

        let UserTableToSave = {
            ...localDemographicState,
            FirstName: localDemographicState.Firstname,
            LastName: localDemographicState.Lastname,
            UserName: localDemographicState.UserName,
            StatusDisplay: localDemographicState.Status === "1" ? "Active" : "InActive",
            BioDOB: localDemographicState.BioDOB
        }

        dispatch(adminparticipantModify(UserTableToSave))

        // phone modificiations

        const sanitizeHome = {
            ...localPhoneStateHome
            , PhoneNumber: sanitizeNull(localPhoneStateHome.PhoneNumber)
        }
        const sanitizeMobile = {
            ...localPhoneStateMobile
            , PhoneNumber: sanitizeNull(localPhoneStateMobile.PhoneNumber)
        }

        if (sanitizeHome.ParticipantPhoneGuid) {
            dispatch(updateParticipantPhones({ ...sanitizeHome, authToken: currentUser.AuthToken }))
        } else {
            dispatch(createParticipantPhones({ ...sanitizeHome, authToken: currentUser.AuthToken }))
        }

        if (sanitizeMobile.ParticipantPhoneGuid) {
            dispatch(updateParticipantPhones({ ...sanitizeMobile, authToken: currentUser.AuthToken }))
        } else {
            dispatch(createParticipantPhones({ ...sanitizeMobile, authToken: currentUser.AuthToken }))
        }



        const sanitizeAddress = {
            ...localAddressState,
            Priority: sanitizeNull(localAddressState.Priority),
            Address1: sanitizeNull(localAddressState.Address1),
            Address2: sanitizeNull(localAddressState.Address2),
            Address3: sanitizeNull(localAddressState.Address3),
            City: sanitizeNull(localAddressState.City),
            PostalCode: sanitizeNull(localAddressState.PostalCode),
            StateProvinceCounty: sanitizeNull(localAddressState.StateProvinceCounty),
            CountryCode: sanitizeNull(localAddressState.CountryCode),
        }

        if (sanitizeAddress.ParticipantAddressGuid) {
            dispatch(updateParticipantAddresss({ ...sanitizeAddress, authToken: currentUser.AuthToken }))
        } else {
            dispatch(createParticipantAddresss({ ...sanitizeAddress, authToken: currentUser.AuthToken }))
        }

        // create / update misc types
        for (var pm = 0; pm < miscTypeState.length; pm++) {
            let sanitizeMiscNew = {
                ParticipantGuid: miscTypeState[pm].ParticipantGuid
                , ParticipantMiscGuid: miscTypeState[pm].ParticipantMiscGuid
                , ParticipantMiscTypeGuid: miscTypeState[pm].ParticipantMiscTypeGuid
                , Priority: sanitizeNull(miscTypeState[pm].Priority)
                , MiscData: sanitizeNull(miscTypeState[pm].MiscData)
            }

            if (sanitizeMiscNew.ParticipantMiscGuid) {
                dispatch(updateParticipantMiscs({ ...sanitizeMiscNew, authToken: currentUser.AuthToken }))
            } else {
                dispatch(createParticipantMiscs({ ...sanitizeMiscNew, authToken: currentUser.AuthToken }))
            }
        }
        //delete misc types
        for (var pm = 0; pm < miscTypeStateActualDelete.length; pm++) {
            let sanitizeMiscNew = {
                ParticipantGuid: miscTypeStateActualDelete[pm].ParticipantGuid
                , ParticipantMiscGuid: miscTypeStateActualDelete[pm].ParticipantMiscGuid
                , ParticipantMiscTypeGuid: miscTypeStateActualDelete[pm].ParticipantMiscTypeGuid
                , Priority: sanitizeNull(miscTypeStateActualDelete[pm].Priority)
                , MiscData: sanitizeNull(miscTypeStateActualDelete[pm].MiscData)
            }

            if (sanitizeMiscNew.ParticipantMiscGuid) {
                dispatch(deleteParticipantMiscs({ ...sanitizeMiscNew, authToken: currentUser.AuthToken }))
            }
        }



        props.cancelButton()
    }

    const handleModifyLocal = (k, v) => {
        let copy = { ...localDemographicState, [k]: v }

        setLocalDemographicState(copy)

    }




    return (
        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={4}>
            <Grid item xs={12}>
                <Typography variant="h4" align="center">Edit Participant</Typography>
            </Grid>
            {isError === true && (

                <Grid item xs={12}>
                    <Typography variant="h6" color="error">
                        {participantdemographicError.ErrorMessage
                            || participantaddressError.ErrorMessage
                            || participantphoneError.ErrorMessage
                            || participantmiscError.ErrorMessage

                        }
                    </Typography>
                </Grid>
            )
            }
            <Grid item xs={12}>
                <Box onClick={() => { handleAllChanges("GROUP") }}>
                    <Typography variant="h5">{isGroupExpanded ? (<ArrowDropUp />) : (<ArrowDropDown />)} {"  "} User Information </Typography>
                </Box>
                <Collapse in={isGroupExpanded} timeout="auto" unmountOnExit>
                    <Box p={3} sx={{ borderBottom: 1 }}>
                        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                            <Grid item xs={12} md={4}>
                                <Typography variant="body1">
                                    Group: {localDemographicState.GroupName}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant="body1">
                                    Status: {localDemographicState.Status === "1" ? "Active" : "Inactive"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant="body1">
                                    Username: {localDemographicState.UserName}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Collapse>
            </Grid>

            <Grid item xs={12}>
                <Box onClick={() => { handleAllChanges("DEMO") }}>
                    <Typography variant="h5">{isDemoExpanded ? (<ArrowDropUp />) : (<ArrowDropDown />)} {"  "} Demographics </Typography>
                </Box>
                <Collapse in={isDemoExpanded} timeout="auto" unmountOnExit>
                    <Box p={3} sx={{ borderBottom: 1 }}>
                        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                            <Grid item xs={12}>
                                <Grid container direction="row" alignItems="center" justifyContent="start" spacing={2}>

                                    <Grid item xs={12} md={4}>
                                        <TextField sx={{ pr: 4 }} margin="dense" fullWidth type="text" variant="standard"
                                            label="First Name"
                                            defaultValue={localDemographicState.Firstname}
                                            onChange={(e, nv) => { setLocalDemographicState({ ...localDemographicState, "Firstname": e.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField sx={{ pr: 4 }} margin="dense" fullWidth type="text" variant="standard"
                                            label="Middle Name"
                                            defaultValue={localDemographicState.Middlename}
                                            onChange={(e, nv) => { setLocalDemographicState({ ...localDemographicState, "Middlename": e.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField sx={{ pr: 4 }} margin="dense" fullWidth type="text" variant="standard" label="Last Name"
                                            defaultValue={localDemographicState.Lastname}
                                            onChange={(e, nv) => { setLocalDemographicState({ ...localDemographicState, "Lastname": e.target.value }) }}
                                        />
                                    </Grid>


                                    <Grid item xs={12} md={4}>
                                        <TextField sx={{ pr: 4 }}
                                            margin="dense"
                                            fullWidth
                                            error={!validDob}
                                            type="date"
                                            variant="standard"
                                            label="Date of Birth"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                inputProps: {
                                                    max: datToday.toISOString().slice(0, 10)
                                                    , min: dat120.toISOString().slice(0, 10)
                                                }
                                            }}
                                            defaultValue={localDemographicState.BioDOB}
                                            onChange={(e, nv) => { setLocalDemographicState({ ...localDemographicState, "BioDOB": e.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField variant="standard" sx={{ width: "100%", overflow: "hidden" }} size="small" select
                                            value={localDemographicState.EducationLevelGuid === "" ? null : localDemographicState.EducationLevelGuid}
                                            label="Education Level"
                                            placeholder="Education Level"
                                            onChange={(e, nv) => { handleModifyLocal("EducationLevelGuid", e.target.value) }}
                                        >
                                            {eduOptions}
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <TextField variant="standard" sx={{ width: "100%", overflow: "hidden" }} select size="small"
                                            value={localDemographicState.SpokenLanguageID < 0 ? null : localDemographicState.SpokenLanguageID}
                                            label="Spoken Language"
                                            placeholder="Spoken Language"
                                            onChange={(e, nv) => { handleModifyLocal("SpokenLanguageID", e.target.value) }}
                                        >
                                            {langOptions}
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <TextField variant="standard" sx={{ width: "100%", overflow: "hidden" }} select size="small"
                                            value={localDemographicState.BioGender < 0 ? null : localDemographicState.BioGender}
                                            label="Birth Sex"
                                            placeholder="Birth Sex"
                                            onChange={(e, nv) => { handleModifyLocal("BioGender", e.target.value) }}
                                        >
                                            {birthSexOptions}
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <TextField variant="standard" sx={{ width: "100%", overflow: "hidden" }} select size="small"
                                            value={localDemographicState.BioRace < 0 ? null : localDemographicState.BioRace}
                                            label="Race"
                                            placeholder="Race"
                                            onChange={(e, nv) => { handleModifyLocal("BioRace", e.target.value) }}
                                        >
                                            {raceOptions}
                                        </TextField>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid>
                    </Box>
                </Collapse>
            </Grid>


            <Grid item xs={12}>
                <Box onClick={() => { handleAllChanges("CONTACT") }}>
                    <Typography variant="h5">{isContactExpanded ? (<ArrowDropUp />) : (<ArrowDropDown />)} {"  "} Contact </Typography>
                </Box>
                <Collapse in={isContactExpanded} timeout="auto" unmountOnExit>
                    <Box p={3} sx={{ borderBottom: 1 }}>
                        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                            <Grid item xs={12} md={4}>
                                <TextField sx={{ pr: 4 }} margin="dense" fullWidth type="text" variant="standard"
                                    label="Email"
                                    defaultValue={localDemographicState.Email}
                                    onChange={(e, nv) => { handleModifyLocal("Email", e.target.value) }}
                                />
                            </Grid>

                            <Grid item xs={0} md={8}>
                            </Grid>


                            <Grid item xs={12} md={4}>
                                <TextField sx={{ pr: 4 }} margin="dense" fullWidth type="text" variant="standard"
                                    label="Phone - Home"
                                    defaultValue={localPhoneStateHome.PhoneNumber}
                                    onChange={(e) => { setLocalPhoneStateHome({ ...localPhoneStateHome, PhoneNumber: e.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField sx={{ pr: 4 }} margin="dense" fullWidth type="text" variant="standard"
                                    label="Phone - Mobile"
                                    defaultValue={localPhoneStateMobile.PhoneNumber}
                                    onChange={(e) => { setLocalPhoneStateMobile({ ...localPhoneStateMobile, PhoneNumber: e.target.value }) }}
                                />
                            </Grid>

                            <Grid item xs={0} md={4}>
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextField sx={{ pr: 4 }} margin="dense" fullWidth type="text" variant="standard"
                                    label="Street Address"
                                    defaultValue={localAddressState.Address1}
                                    onChange={(e) => { setLocalAddressState({ ...localAddressState, Address1: e.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>

                                <TextField variant="standard" sx={{ width: "100%", overflow: "hidden" }} select size="small"
                                    value={localAddressState.CountryCode < 0 ? null : localAddressState.CountryCode}
                                    label="Country"
                                    placeholder="Country"
                                    onChange={(e) => { setLocalAddressState({ ...localAddressState, CountryCode: e.target.value }) }}
                                >
                                    {countryOptions}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField sx={{ pr: 4 }} margin="dense" fullWidth type="text" variant="standard"
                                    label="City"
                                    defaultValue={localAddressState.City}
                                    onChange={(e) => { setLocalAddressState({ ...localAddressState, City: e.target.value }) }}
                                />

                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField sx={{ pr: 4 }} margin="dense" fullWidth type="text" variant="standard"
                                    label="State"
                                    defaultValue={localAddressState.StateProvinceCounty}
                                    onChange={(e) => { setLocalAddressState({ ...localAddressState, StateProvinceCounty: e.target.value }) }}
                                />

                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField sx={{ pr: 4 }} margin="dense" fullWidth type="text" variant="standard"
                                    label="Postal Code"
                                    defaultValue={localAddressState.PostalCode}
                                    onChange={(e) => { setLocalAddressState({ ...localAddressState, PostalCode: e.target.value }) }}
                                />

                            </Grid>
                        </Grid>
                    </Box>
                </Collapse>
            </Grid>

            <Grid item xs={12}>
                <Box onClick={() => { handleAllChanges("OTHER") }}>
                    <Typography variant="h5">{isOtherExpanded ? (<ArrowDropUp />) : (<ArrowDropDown />)} {"  "} Misc </Typography>
                </Box>
                <Collapse in={isOtherExpanded} timeout="auto" unmountOnExit>

                    <Box p={3} sx={{ borderBottom: 1 }}>
                        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>

                            <Grid item xs={12}>
                                <Grid container direction="row" alignItems="center" justifyContent="left" spacing={2}>

                                    {
                                        miscTypeState.map((x, i) => {

                                            return (
                                                <Grid item xs={12} md={4}>
                                                    <Box p={2} sx={{ border: 1, borderColor: "#00000020", borderRadius: "5px" }}>
                                                        <Grid container direction="row" alignItems="center" justifyContent="center">
                                                            <Grid item xs={12}>
                                                                <TextField variant="standard" sx={{ width: "100%", overflow: "hidden" }} select
                                                                    fullWidth
                                                                    value={miscTypeState[i].ParticipantMiscTypeGuid < 0 ? null : miscTypeState[i].ParticipantMiscTypeGuid}
                                                                    label="Misc Type"
                                                                    placeholder="Misc Type"
                                                                    onChange={(e) => { handleMiscTypeEdit(i, 'ParticipantMiscTypeGuid', e.target.value) }}
                                                                >
                                                                    {miscTypeOptions}
                                                                </TextField>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <TextField variant="standard"
                                                                    fullWidth
                                                                    value={miscTypeState[i].MiscData < 0 ? null : miscTypeState[i].MiscData}
                                                                    label="Misc Data"
                                                                    placeholder="Misc Data"
                                                                    onChange={(e) => { handleMiscTypeEdit(i, 'MiscData', e.target.value) }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={10}>
                                                                <TextField variant="standard"
                                                                    fullWidth
                                                                    value={miscTypeState[i].Priority < 0 ? null : miscTypeState[i].Priority}
                                                                    label="Priority"
                                                                    placeholder="Priority"
                                                                    onChange={(e) => { handleMiscTypeEdit(i, 'Priority', e.target.value) }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={2} >
                                                                <Delete onClick={() => handleMiscTypeDelete(i)} />
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Grid>
                                            )
                                        })
                                    }
                                    <Grid item xs={12}>
                                        <AddCircleOutline sx={{ color: "#209D70" }} onClick={() => { if (miscTypeState.length < 9) { AddMiscType(); } }} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Collapse>
            </Grid>

            <Grid item xs={12} justifyContent="center">
                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                    <Grid item xs={3}>
                        <Box display="flex" justifyContent="center">
                            <Button fullWidth variant="contained" color="success"
                                disabled={!validDob}
                                onClick={() => { SaveToDatabase() }}>Save</Button>
                        </Box>
                    </Grid>
                    <Grid item xs={3}>
                        <Box display="flex" justifyContent="center">
                            <Button fullWidth variant="contained" color="error" onClick={() => { props.cancelButton() }}>Cancel</Button>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

        </Grid>
    )

}
export default ParticipantEdit
